import { type Token } from '@/shared/assets/tokens';
import { SkeletonLine } from '@/shared/components';
import useTokenPrice from '@/shared/hooks/useTokenPrice';
import { formatUsdValue, type TokenAmount } from '@/shared/utils';

export const UsdAmount = ({
  token,
  tokenAmount,
  withParens,
}: {
  token: Token | undefined;
  tokenAmount: TokenAmount | undefined;
  withParens?: boolean;
}) => {
  const { price, isLoading } = useTokenPrice(token);

  if (!tokenAmount) {
    if (withParens) return `(${formatUsdValue(0)})`;
    return formatUsdValue(0);
  }
  if (!price && isLoading) return <SkeletonLine width={30} inline />;
  if (!price) return null;

  const formatted = formatUsdValue(tokenAmount.mul(price).toBigNumber());
  if (formatted.includes('NaN')) return null;

  return withParens ? `(${formatted})` : formatted;
};
